import { LogoIcon } from '@/components/icons';
import { Button } from '@/components/ui/Button';
import { Bell, Menu, Search, User } from 'lucide-react';
import React from 'react';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <header className="h-16 sm:h-20 lg:h-24 bg-gradient-to-r from-black/30 via-black/20 to-black/30 backdrop-blur-2xl border-b border-white/20 shadow-lg shadow-black/20 flex items-center justify-between px-3 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4 relative z-10">
      {/* Mobile menu button */}
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onMenuClick}
        className="lg:hidden mr-2"
      >
        <Menu className="h-5 w-5" />
      </Button>

      {/* Logo section */}
      <div className="flex items-center space-x-2 sm:space-x-3 sm:w-64 flex-shrink-0">
        <LogoIcon className="w-10 h-10 sm:w-10 sm:h-10 lg:w-14 lg:h-14 sm:ml-4" />
        <div className="hidden sm:block">
          <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-300">GenAI Jury</h1>
          <p className="text-xs sm:text-sm text-gray-300">AI Jury Simulation</p>
        </div>
      </div>

      {/* Search - centered and expanded - Hidden on mobile */}
      <div className="hidden md:flex flex-1 max-w-2xl mx-4 lg:mx-8">
        <div className="relative w-full">
          <Search className="absolute left-3 lg:left-5 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <input
            type="text"
            placeholder="Search cases, jurors, simulations..."
            className="glass-input w-full"
          />
        </div>
      </div>

      {/* Right side actions */}
      <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4 flex-shrink-0">
        {/* Notifications */}
        <Button variant="ghost" size="sm">
          <Bell className="h-4 w-4 sm:h-5 sm:w-5" />
        </Button>

        {/* User menu */}
        <Button variant="ghost" size="sm">
          <User className="h-4 w-4 sm:h-5 sm:w-5" />
        </Button>

        {/* Status indicator - Hidden on mobile */}
        <div className="hidden xl:flex items-center space-x-2 text-sm">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-gray-300">All Systems Operational</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
